/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBookingSequential201, PostApiBookingSequentialMutationRequest, PostApiBookingSequentialMutationResponse, PostApiBookingSequentialQueryParams } from "../entities/PostApiBookingSequential";
import { modelsBookingGroupOutputSchema } from "./models/bookingGroupOutputSchema";
import { modelsBookingSequentialInputSchema } from "./models/bookingSequentialInputSchema";
import { z } from "zod/v4";

export const postApiBookingSequentialQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiBookingSequentialQueryParams>

/**
 * @description Created
 */
export const postApiBookingSequential201Schema = z.lazy(() => modelsBookingGroupOutputSchema) as unknown as z.ZodType<PostApiBookingSequential201>

/**
 * @description Данные последовательной записи
 */
export const postApiBookingSequentialMutationRequestSchema = z.lazy(() => modelsBookingSequentialInputSchema) as unknown as z.ZodType<PostApiBookingSequentialMutationRequest>

export const postApiBookingSequentialMutationResponseSchema = z.lazy(() => postApiBookingSequential201Schema) as unknown as z.ZodType<PostApiBookingSequentialMutationResponse>